import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import { Row, Col, Modal, Form, Input, Select } from 'antd';

import { toggleMember, addMember, updateMember } from 'containers/App/actions';
import {
  selectErrors,
  selectIsLoading,
  selectMembers,
} from 'containers/App/selectors';
import { default as Loader } from 'components/Loader';

import MemberItem from './member-item';

import 'antComponentsStyle';

class SideColumn extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isModalOpen: false,
      member: {},
      otherMembers: [],
    };
  }

  componentDidUpdate(prevProps) {
    const { profile: { members: prevMembers } } = prevProps;
    const { profile: { members } } = this.props;

    if (members !== prevMembers) {
      this.setState({ isModalOpen: false });
    }
  }

  toggleModal = () => this.setState({ isModalOpen: !this.state.isModalOpen });

  openModal = member => {
    const { members } = this.props;
    const otherMembers = member
      ? members.filter(otherMember => otherMember.code !== member.code)
      : members;

    this.setState(
      {
        member: {
          ...(member || {}),
        },
        otherMembers,
      },
      () => this.setState({ isModalOpen: true }),
    );
  };

  onChangeMemberFieldValue = ({ target: { name, value } }) =>
    this.setState({
      member: {
        ...this.state.member,
        [name]: value,
      },
    });

  onChangeParentValue = value =>
    this.setState({
      member: {
        ...this.state.member,
        parent_id: value,
      },
    });

  onChangeFeeType = value =>
    this.setState({
      member: {
        ...this.state.member,
        fee_type: value,
      },
    });

  submitMember = () => {
    if (this.state.member.code) {
      this.props.updateMember(this.state.member);
    } else {
      this.props.addMember(this.state.member);
    }
  };

  toggleMember = agentId => this.props.toggleMember(agentId);

  render() {
    const { profile, hasNetwork, errors: { member: errors={}}, isLoading, members } = this.props;
    const { member, otherMembers } = this.state;

    let membersCount = members.length;

    let memberHasOtherMembers = false;

    if (hasNetwork) {
      const subAgentFeature = profile.features.find(
        feature => feature.slug === 'network-sub-agent',
      );

      membersCount = subAgentFeature ? subAgentFeature.limit : members.length;
    }

    const membersCountResume = membersCount - members.length;

    const feeTypes = {
      FIXED_VALUE: 'Gettone fisso',
      FLAT_PERCENTAGE: 'Percentuale FLAT',
      HIERARCHICAL_PERCENTAGE: 'Percentuale gerarchica'
    };

    if (profile.group_fee_type !== 'FIXED_VALUE') {
      delete feeTypes.FIXED_VALUE;
    }

    return (
      <>
        <div className="user-profile compact full-chat-w">
          <div className="element-wrapper">
            <div className="user-intro">
              <div className="mb-4 px-4">
                <img alt="Logo" src={profile.logo} className="img-fluid" />
              </div>
              <div className="user-intro-info">
                {profile.role === 1 &&
                  <h5 className="user-name">{profile.business_name}</h5>
                }
                <h5 className="user-name">{profile.name}</h5>
                <div className="user-title">{profile.email}</div>
                {hasNetwork &&
                  <div className="user-sub">
                    {profile.roleName}
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
        {hasNetwork && profile.role === 1 && (
          <div className="element-wrapper position-relative">
            <h1 className="element-header text-medium">Il mio team ({members.length})</h1>
            <Loader loading={isLoading} />
            {!isLoading &&
            <div className="element-box-tp">
              {members && Array.isArray(members) && members.map(member => (
                <MemberItem
                  key={member.code}
                  member={member}
                  onOpenModal={() => this.openModal(member)}
                  onToggleMember={!isLoading ? () => this.toggleMember(member.code) : null}
                />
              ))}
              {membersCountResume && membersCountResume > 0 ?
                [...Array(membersCountResume).keys()].map(idx =>
                  <MemberItem
                    key={idx}
                    member={{}}
                    onOpenModal={() => this.openModal()}
                    onCreate={this.addMemberHanlder}
                  />
                )
                : null
              }
            </div>
            }

            <Modal
              title={member.code ? 'Modifica agente ' + member.name : 'Aggiungi agente'}
              visible={this.state.isModalOpen}
              onOk={() => this.submitMember()}
              onCancel={this.toggleModal}
              okText="Salva"
              cancelText="Annulla"
              destroyOnClose
            >
              <Loader loading={isLoading} />
              <Form layout="vertical">
                <Form.Item label="Ragione sociale" required help={errors.business_name && errors.business_name[0]} validateStatus={errors.business_name ? 'error' : null}>
                  <Input placeholder="Ragione sociale" name="business_name" value={member.business_name} onChange={this.onChangeMemberFieldValue} required />
                </Form.Item>
                <Form.Item label="Nome e cognome" help={errors.name && errors.name[0]} validateStatus={errors.name ? 'error' : null}>
                  <Input placeholder="Nome e cognome agente" name="name" value={member.name} onChange={this.onChangeMemberFieldValue} />
                </Form.Item>
                <Form.Item label="Titolo">
                  <Input placeholder="Ruolo ricoperto" name="title" value={member.title} onChange={this.onChangeMemberFieldValue} />
                </Form.Item>
                <Form.Item label="Email" required help={errors.email && errors.email[0]} validateStatus={errors.email ? 'error' : null}>
                  <Input placeholder="Indirizzo email" name="email" type="email" value={member.email} onChange={this.onChangeMemberFieldValue} required />
                </Form.Item>
                <Form.Item label="Telefono" required help={errors.phone && errors.phone[0]} validateStatus={errors.phone ? 'error' : null}>
                  <Input placeholder="Numero di telefono" type="number" name="phone" value={member.phone} onChange={this.onChangeMemberFieldValue} required />
                </Form.Item>
                <Row gutter={16}>
                  <Col span={14}>
                    <Form.Item label="Tipologia commissioni" required help={errors.fee_type && errors.fee_type[0]} validateStatus={errors.fee_type ? 'error' : null}>
                      <Select name="fee_type" defaultValue={member.fee_type || null} onChange={this.onChangeFeeType} required>
                        {Object.entries(feeTypes).map(([feeTypeValue, feeTypeLabel]) =>
                          <Select.Option value={feeTypeValue} key={feeTypeValue}>{feeTypeLabel}</Select.Option>
                        )}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col span={10}>
                    <Form.Item label="Commissioni" required help={errors.fee_value && errors.fee_value[0]} validateStatus={errors.fee_value ? 'error' : null}>
                      <Input
                        placeholder="Valore commissioni"
                        name="fee_value"
                        required
                        type="number"
                        min="0"
                        max={member.fee_type !== 'FIXED_VALUE' ? 100 : null}
                        value={member.fee_value}
                        addonAfter={member.fee_type === 'FIXED_VALUE' ? '€' : '%'}
                        onChange={this.onChangeMemberFieldValue}
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Form.Item label="Agente di riferimento" help={errors.parent_id && errors.parent_id[0]} validateStatus={errors.parent_id ? 'error' : null}>
                  <Select name="parent_id" defaultValue={member.parent_id || null} onChange={this.onChangeParentValue} disabled={memberHasOtherMembers}>
                    <Select.Option value={null}>nessuno</Select.Option>
                    {otherMembers.map(otherMemmber =>
                      <Select.Option value={otherMemmber.code} key={otherMemmber.code}>{otherMemmber.name}</Select.Option>
                    )}
                  </Select>
                </Form.Item>
              </Form>
              {errors && Array.isArray(errors.member) && errors.member.length > 0 ? <div className="text-danger">{errors.member[0]}</div> : null}
            </Modal>
          </div>
        )}
      </>
    );
  }
}


const mapStateToProps = createStructuredSelector({
  isLoading: selectIsLoading(),
  errors: selectErrors(),
  members: selectMembers(),
});

export function mapDispatchToProps(dispatch) {
  return {
    toggleMember: agentId => dispatch(toggleMember(agentId)),
    addMember: agentData => dispatch(addMember(agentData)),
    updateMember: agentData => dispatch(updateMember(agentData)),
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export default compose(withConnect)(SideColumn);
